@if(abpOauthService.isAuthenticated){
<app-vertical></app-vertical>
}
@if(loaderService.showLoader()){
<div class="blocking-overlay" aria-hidden="true"></div>
<div class="top-loader" aria-hidden="true">
    <div class="bar" [style.width.%]="loaderService.progressValue()"></div>
</div>
}
